module.exports = __webpack_public_path__ + "static/legend-placement-do-400b36b754f7b7376dd803827843f5e5.png";